import * as Yup from 'yup';
import { isValidPesel } from '../../helpers/validation';

export const schema = Yup.object().shape({
    pesel: Yup.string()
        .trim()
        .required('Pesel jest wymagany')
        .test('pesel', 'Nieprawidłowy pesel.', (value) => isValidPesel(value)),
});
